/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import Grid from '@material-ui/core/Grid';
import withStyles from '@material-ui/core/styles/withStyles';
import PropTypes from 'prop-types';

const styles = (theme) => ({
    secureCheckout: {
        fill: theme.palette.cms?.secureCheckoutColor || theme.palette.bgHeader,
        display: 'flex',
        paddingTop: '2px',
        width: '86px',
        fontSize: '11px',
        float: 'right',
        fontWeight: '600',
        height: '30px',
        [theme.breakpoints.down('md')]: {
            padding: '0 10px',
            width: '116px',
        },
        [theme.breakpoints.down('md')]: {
            padding: '0',
            float: 'left',
        },
    },
});

const SecureCheckout = ({ classes, dataDictionary }) => (
    <Grid container direction="row" xl className={classes.secureCheckout}>
        <Grid container className={classes.secureCheckout}>
            <svg viewBox="0 0 72 22" preserveAspectRatio="xMidYMid meet" className={classes.secureCheckout}>
                <g>
                    <text transform="matrix(1 0 0 1 21.9277 9.9502)">{dataDictionary?.['Secure'] || 'Secure'}</text>
                    <text transform="matrix(1 0 0 1 21.9277 20.9502)">{dataDictionary?.['Checkout'] || 'Checkout'}</text>
                    <path d="M9,15.6v1.1c0,0.5,0.4,1,1,1c0.5,0,1-0.4,1-1v-1.1c0.6-0.3,1-1,1-1.7c0-1.1-0.9-2-2-2s-2,0.9-2,2  C8,14.6,8.4,15.2,9,15.6L9,15.6z M16.2,18.3c0,0.2,0,1.6-1.4,1.7c-2,0.1-9.8,0-9.9,0c-0.1,0-1.2-0.1-1.4-2v-7.8h12.6L16.2,18.3  L16.2,18.3z M9.9,2c3.8,0,4,3.2,4,3.5v3.3h-8V5.6C5.9,5.5,6,2,9.9,2L9.9,2z M16.9,8.8h-1.6V5.4c0-1.7-1.2-4.8-5.4-4.8  s-5.3,3.3-5.4,5v3.2H3c-0.4,0-0.7,0.3-0.7,0.7v8.6c0,0,0,0,0,0.1c0.3,2.6,1.9,3.3,2.7,3.2c0.2,0,3.4,0,6.1,0c1.6,0,3.1,0,3.8,0  c2.1-0.1,2.7-2,2.7-3V9.5C17.6,9.1,17.3,8.8,16.9,8.8L16.9,8.8z" />
                </g>
            </svg>
        </Grid>
    </Grid>
);

SecureCheckout.defaultProps = {
    dataDictionary: {},
};

SecureCheckout.propTypes = {
    classes: PropTypes.object.isRequired,
    dataDictionary: PropTypes.object,
};

export default withStyles(styles)(SecureCheckout);
